import styled from "styled-components";

export const AiAssistantButton = styled.button`
  height: 2.4rem;
  width: 2.4rem;
  margin-right: 0.8rem;
  cursor: pointer;
  vertical-align: middle;
  outline: none;
  padding: 0;
  border: none;
  background: none;

  img {
    width: 100%;
    height: 100%;
  }
`;
